import { Supplies, Registers, Reports, Filters } from '@factorin/domain';

import { get, withUrl } from '../rest';


export interface PlatformParticipant {
    Uid: string;
    Uri: string;
    CompanyUid: string;
    ShortName: string;
    FullName: string;
    DltKey: string;
    AllowNotifications: boolean;
}

export interface ProcessTemplateInstance {
    Code: string;
    Mask: string;
    ProcessTemplate: Filters.FilterDefinition;
}

export interface ContractorRoles extends Filters.FilterDefinition {
    Uid: string;
}

export interface Currency {
    key: string;
    value: string;
}

const dictsMethod = withUrl('dicts');
const dict = <TDict>(path: string) =>
    get<void, TDict[]>(() => dictsMethod({ path }));

const userTemplates = withUrl('registertemplates');

export const dicts = {
    supplies: {
        rejectReasons: dict<Supplies.SupplyRejectReason>('supplies/rejectreasons'),
    },

    registers: {
        stages: dict<Registers.RegisterStage>('registers/stages'),

        statuses: dict<Registers.RegisterStatus>('registers/statuses'),

        templates: dict<Registers.RegisterTemplate>('registers/templates'),
    },

    platformParticipants: dict<PlatformParticipant>('system/platformparticipants'),

    processTemplates: dict<Filters.FilterDefinition>('processtemplates'),

    processTemplateInstances: dict<ProcessTemplateInstance>('processtemplateinstances'),

    documentTypes: dict<Filters.FilterDefinition>('documenttypes'),

    reports: {
        types: dict<Reports.ReportType>('reports/types'),

        periods: dict<Reports.ReportDictItem>('reports/periods'),

        statuses: dict<Reports.ReportDictItem>('reports/statuses'),
    },

    contractorroles: dict<ContractorRoles>('contractorroles'),

    userRegisterTemplates: get<void, Registers.RegisterTemplate>(
        () => userTemplates({ path: 'available' }),
    ),

    currency: dict<Currency>('currency'),
};
